import React, { useState } from "react";
import { StyledSection } from "./styled";
import { Input, Space, Typography } from "antd";
import { regex } from "../../../../helpers";

const Step4 = ({ data, setData }) => {
  const [inputError, SetInputError] = useState({
    name: "",
    phone: "",
    email: "",
  });
  const customStyles = {
    borderRadius: "50px",
    background: "#5062861A",
    marginBottom: 20,
    height: "2.4375rem",
  };
  const textStyle = {
    color: "#263E5F",
    fontSize: "1rem",
  };

  const errorStyle = {
    color: "red",
    position: "relative",
    bottom: 16,
  };
  const handleInput = (e) => {
    const name = e.target.name || "";
    const value = e.target.value;
    let valid = false;
    let error = "";
    switch (name) {
      case "phone":
        if (value.match(regex.phone2)) {
          valid = true;
          error = "";
        } else {
          error = "Le format du téléphone est incorrect";
        }
        break;
      case "email":
        if (value.match(regex.email)) {
          valid = true;
          error = "";
        } else {
          error = "Le format du mail est incorrect";
        }
        break;
      default:
        valid = true;
        break;
    }
    if (valid) {
      setData({ ...data, [name]: value });
    } else {
      setData({ ...data, [name]: "" });
    }
    SetInputError({ ...inputError, [name]: error });
  };
  return (
    <StyledSection>
      {/* NAME INPUT */}
      <Typography style={textStyle}>Votre Nom *:</Typography>
      <Input name="name" required onChange={handleInput} style={customStyles} />
      {/* PHONE INPUT */}
      <Typography style={textStyle}>Votre Téléphone *:</Typography>
      <Input
        name="phone"
        required
        onChange={handleInput}
        style={customStyles}
      />
      <Typography style={errorStyle}>{inputError.phone}</Typography>

      {/* MAIL INPUT */}
      <Typography style={textStyle}>Votre E-MAIL *:</Typography>
      <Input
        type="email"
        name="email"
        required
        onChange={handleInput}
        style={customStyles}
      />
      <Typography style={errorStyle}>{inputError.email}</Typography>
    </StyledSection>
  );
};

export default Step4;
